import { __decorate } from "tslib";
import { computed } from 'mobx';
import { columnWidth } from './Column';
import ColumnGroup from './ColumnGroup';
import { ColumnLock } from './enum';
export default class ColumnGroups {
    constructor(columns, store, parent) {
        this.store = store;
        this.parent = parent;
        let prev;
        this.columns = columns.map(col => {
            const group = new ColumnGroup(col, this, store);
            if (prev) {
                prev.next = group;
                group.prev = prev;
            }
            prev = group;
            return group;
        });
    }
    get aggregation() {
        return this.store.aggregation;
    }
    get wide() {
        return this.columns.reduce((sum, { colSpan, hidden }) => (hidden ? sum : sum + colSpan), 0);
    }
    get deep() {
        return Math.max(...this.columns.map(({ deep }) => deep));
    }
    get hidden() {
        return this.columns.every(({ hidden }) => hidden);
    }
    get width() {
        return this.columns.reduce((sum, { width }) => sum + width, 0);
    }
    get left() {
        const { parent } = this;
        if (parent) {
            return parent.left;
        }
        return 0;
    }
    get right() {
        const { parent } = this;
        if (parent) {
            return parent.right;
        }
        return 0;
    }
    get lastLeaf() {
        const { leafs } = this;
        const { length } = leafs;
        return length ? leafs[length - 1] : undefined;
    }
    get allLeafs() {
        const { aggregation } = this;
        return this.columns.reduce((leafs, group) => leafs.concat(aggregation && group.column.aggregation ? group : group.allLeafs), []);
    }
    get inView() {
        return this.allLeafs.some(group => group.inView !== false);
    }
    get leafs() {
        const { aggregation, hidden } = this;
        return hidden ? [] : this.columns.reduce((leafs, group) => group.hidden ? leafs : leafs.concat(aggregation && group.column.aggregation ? group : group.leafs), []);
    }
    get leftLeafs() {
        if (!this.parent) {
            const { aggregation } = this;
            return this.columns.reduce((leafs, group) => group.lock === ColumnLock.left && !group.hidden ? leafs.concat(aggregation && group.column.aggregation ? group : group.leafs) : leafs, []);
        }
        return [];
    }
    get rightLeafs() {
        if (!this.parent) {
            const { aggregation } = this;
            return this.columns.reduce((leafs, group) => group.lock === ColumnLock.right && !group.hidden ? leafs.concat(aggregation && group.column.aggregation ? group : group.leafs) : leafs, []);
        }
        return [];
    }
    get leafColumnsWidth() {
        return this.allLeafs.reduce((total, { column }) => total + columnWidth(column, this.store), 0);
    }
    get leftLeafColumnsWidth() {
        return this.leftLeafs.reduce((total, { column }) => total + columnWidth(column, this.store), 0);
    }
    get rightLeafColumnsWidth() {
        return this.rightLeafs.reduce((total, { column }) => total + columnWidth(column, this.store), 0);
    }
    get headerGroup() {
        const { parent } = this;
        if (parent) {
            return parent.headerGroup;
        }
    }
    get tableGroup() {
        const { parent } = this;
        if (parent) {
            return parent.tableGroup;
        }
    }
}
__decorate([
    computed
], ColumnGroups.prototype, "wide", null);
__decorate([
    computed
], ColumnGroups.prototype, "deep", null);
__decorate([
    computed
], ColumnGroups.prototype, "hidden", null);
__decorate([
    computed
], ColumnGroups.prototype, "width", null);
__decorate([
    computed
], ColumnGroups.prototype, "allLeafs", null);
__decorate([
    computed
], ColumnGroups.prototype, "inView", null);
__decorate([
    computed
], ColumnGroups.prototype, "leafs", null);
__decorate([
    computed
], ColumnGroups.prototype, "leftLeafs", null);
__decorate([
    computed
], ColumnGroups.prototype, "rightLeafs", null);
